import { render } from "./LkCheckboxBase.vue?vue&type=template&id=d3e3c52c"
import script from "./LkCheckboxBase.vue?vue&type=script&lang=js"
export * from "./LkCheckboxBase.vue?vue&type=script&lang=js"

import exportComponent from "D:\\FreedomLk\\legal-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__